import imomoStationCreatorModule from './creator/creator.module';
import managerComponent from './manager.component';
import stationComponent from './station.component';
import selectorComponent from './selector/selector.component';
import historicNormComponent from './historic-norm/historic-norm.component';
import curveComponent from './curve/curve.component';
import detailsComponent from './details/details.component';
import detailsEditComponent from './details/edit.component';
import stationFormatterFactory from './station.formatter';

import {uniqueStationCodeFactory} from './unique-station-code.directive';
import {configStates} from './station.component';
import StationSelectorService from './selector/selector.service';
import timeseriesComponent from './timeseries/timeseries.component';
import TimeseriesService from './timeseries/timeseries.service';
import aggregationsEditComponent from './aggregation/aggregationEdit.component';
import forecastModelComponent from './forecast-model/forecast-model.component';
import ForecastModelService from './forecast-model/forecast-model.service';
import snowDataComponent from './snow-data/snow-data.component';
import StationMapService from './station-map.service';

export default angular.module('imomo.station', [imomoStationCreatorModule.name])
    .component('imomoStation', stationComponent)
    .component('imomoStationManager', managerComponent)
    .component('imomoStationSelector', selectorComponent)
    .component('imomoStationHistoricNorm', historicNormComponent)
    .component('imomoStationCurve', curveComponent)
    .component('imomoStationDetails', detailsComponent)
    .component('imomoStationDetailsEdit', detailsEditComponent)
    .component('imomoStationAggregationsEdit', aggregationsEditComponent)
    .component('imomoStationSnowData', snowDataComponent)
    .component('imomoStationTimeseries', timeseriesComponent)
    .component('imomoStationForecastModel', forecastModelComponent)
    .config(configStates)
    .filter('stationFormatter', stationFormatterFactory)
    .directive('uniqueDischargeStationCode', uniqueStationCodeFactory)
    .service('stationSelectorService', StationSelectorService)
    .service('forecastingService', ForecastModelService)
    .service('stationMapService', StationMapService)
    .service('timeseriesService', TimeseriesService)
    .name;



/** WEBPACK FOOTER **
 ** ./app/station/station.module.ts
 **/